<template>
  <div>
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import Autenticacao from '@/services/Autenticacao'

  export default {
    name: 'VerifyEmailCtrl',
    created () {
      const query = this.$route.query
      if (query.mode && query.mode === 'verifyEmail' && query.oobCode) {
        Autenticacao.verificarEmail(query.oobCode)
          .then(() => {
            Swal(
              'Validação de conta!',
              `Sua conta foi validada com sucesso, você pode agora entrar!`,
              'success'
            ).then(() => {
              this.$router.push({
                name: 'entrar'
              })
            })
          })
          .catch(() => {
            Swal(
              'Erro na validação de sua conta!',
              `Aparentemente seu código está errado, favor entrar em contato com o suporte!`,
              'error'
            )
            .then(() => {
              this.$router.push({
                name: 'entrar'
              })
            })
          })
      } else {
        this.$router.push({
          name: 'entrar'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GeneralViews/VerifyEmail.vue